module.exports = __webpack_public_path__ + "img/002-instagram.40512ccf.svg";